import makeStyles from "@material-ui/core/styles/makeStyles";
import {Sticky} from "react-sticky";
import clsx from "clsx";
import React from "react";
import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
    searchBarPaperNoSticky: {
        position: "relative"
    }
}));

const StickySearchBarContainer = ({
    children
}) => {
    const classes = useStyles();

    return (
        <Sticky>
            {({style, isSticky}) => (
                <div
                    className={clsx(
                        {[classes.searchBarPaperNoSticky]: !isSticky}
                    )}
                    style={{...style, transform: "unset", zIndex: 3}}
                >
                    {children}
                </div>
            )}
        </Sticky>
    );
};

StickySearchBarContainer.defaultProps = {

};

StickySearchBarContainer.propTypes = {
    children: PropTypes.any
};

export default StickySearchBarContainer;
